import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "antd";
import SignatureCanvas from "react-signature-canvas";

const RentalSignature = ({ onSignatureObject, clearLabel = "Clear" }) => {
    const signatureRef = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(600);

    useEffect(() => {
        const updateWidth = () => {
            if (window.innerWidth >= 1440) setCanvasWidth(973);
            else if (window.innerWidth >= 1280) setCanvasWidth(882);
            else if (window.innerWidth >= 1024) setCanvasWidth(697);
            else if (window.innerWidth >= 768) setCanvasWidth(593);
            else if (window.innerWidth >= 425) setCanvasWidth(330);
            else if (window.innerWidth >= 375) setCanvasWidth(280);
            else setCanvasWidth(280);
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    const handleSignatureEnd = useCallback(() => {
        const canvas = signatureRef.current;
        if (canvas && !canvas.isEmpty()) {
            onSignatureObject(canvas);
        }
    }, [onSignatureObject]);

    const handleSignatureClear = () => {
        signatureRef.current?.clear();
        onSignatureObject(null);
    };

    return (
        <div className="relative w-full overflow-hidden rounded-sm border border-[#CBD5E0] bg-white">
            <SignatureCanvas
                ref={signatureRef}
                penColor="blue"
                backgroundColor="white"
                clearOnResize={false}
                canvasProps={{
                    width: canvasWidth,
                    height: 150,
                    className: "sigCanvas bg-white",
                }}
                onEnd={handleSignatureEnd}
            />
            <Button type="primary" size="small" onClick={handleSignatureClear} className="!absolute !right-1 !top-1">
                {clearLabel}
            </Button>
        </div>
    );
};

RentalSignature.propTypes = {
    onSignatureObject: PropTypes.func.isRequired,
    clearLabel: PropTypes.string,
};

export default RentalSignature;
